import React from "react";
import styled from "styled-components";

import imagemFundo from "../../images/imagemfundo.png";

import disponibilizar from "../../images/disponibilizar.svg";
import Globais from "../../css/Globais";

const Container = styled.section`
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #fff;
  opacity: 80%;
`;
const Imagem = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 90%;
  border-radius: 30%;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  @media (min-width: 300px) {
    width: 80%;
  }
  @media (min-width: 400px) {
    width: 60%;
  }
  @media (min-width: 600px) {
    width: 40%;
  }
  @media (min-width: 800px) {
    width: 30%;
  }
`;

const ContainerTermo = styled.div`
  width: 100%;

  height: 100%;
  max-width: 80rem;
  min-width: 15rem;
  min-height: 30rem;
  justify-self: flex-start;

  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  background-color: #fff;
  border-radius: 30px;
  position: absolute;
  z-index: 0;
  display: grid;
  grid-template: 20% 80%/ 100%;
  justify-content: center;
  aligm-itens: center;
  @media (min-height: 1000px) {
    height: 80%;
  }
  @media (min-height: 1000px) {
    height: 70%;
  }
`;

const TextWrapper = styled.div`
  display: flex;

  justify-content: flex-start;

  margin-left: 2rem;
  margin-right: 2rem;
  overflow: auto;

  flex-direction: column;
  @media (min-width: 450px) {
    margin-left: 5rem;
    margin-right: 5rem;
  }
  a {
    color: #2d3436;
  }
  a:hover {
    color: #636e72;
  }
`;

const ContainerTitulo = styled.div`
  width: 100%;

  height: 100%;
  display: flex;
  justify-content: center;
`;

const Titulo = styled.h1`
  text-align: center;
  align-self: center;
  color: ${Globais.CorAzulBackGround};
  font-size: 1.2rem;

  width: 80%;

  @media (min-width: 300px) {
    font-size: 1.4rem;
  }
  @media (min-width: 700px) {
    font-size: 1.8rem;
  }
`;

const H3 = styled.h3`
  text-align: center;

  color: ${Globais.CorAzulBackGround};
  font-size: 1rem;
  @media (min-width: 500px) {
    font-size: 1.2rem;
  }
`;

export default function ViewPosCadastroCotasEmpreendChecados() {
  return (
    <Container>
      <Imagem src={imagemFundo} alt="" />
      <ContainerTermo>
        <ContainerTitulo>
          <Titulo>
            PARABÉNS! <br />
            SUA COTA FOI CADASTRADA COM SUCESSO!
          </Titulo>
        </ContainerTitulo>

        <TextWrapper>
          <H3>
            <p>
              Pronto. <br />{" "}
            </p>
            <p>
              Agora que cadastrou a sua cota, basta efetuar mais dois
              procedimentos.
            </p>
            <p>
              Um deles é a comprovação de sua propriedade. Verifique no seu
              e-mail (aquele cadastrado) as instruções necessárias para
              comprovação. (caso não encontre procure na pasta de Spam.)
            </p>
            O segundo passo é{" "}
            <a href="/cadastrocotas">disponibilizar seus períodos</a> para
            aluguel ou troca. Inclusive você já pode disponibilizar os seus
            períodos mesmo que não tenha comprovado sua propriedade.
            <p>
              Caso tenha dúvidas, clique na imagem abaixo e veja como
              disponibilizar seu período.
            </p>
            <p>
              {" "}
              <a href="comodisponibilizarseuperiodo">
                <Imagem src={disponibilizar}></Imagem>
              </a>
            </p>{" "}
          </H3>
        </TextWrapper>
      </ContainerTermo>
    </Container>
  );
}
